import { render, staticRenderFns } from "./baseImgPreview.vue?vue&type=template&id=905a8ebe&scoped=true&"
import script from "./baseImgPreview.vue?vue&type=script&lang=js&"
export * from "./baseImgPreview.vue?vue&type=script&lang=js&"
import style0 from "./baseImgPreview.vue?vue&type=style&index=0&id=905a8ebe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905a8ebe",
  null
  
)

export default component.exports